// Tiny axios wrapper - centralises base URL + JSON defaults
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

export const fetchMenu = () => api.get("/menu").then((r) => r.data);
export const fetchPlans = () => api.get("/plans").then((r) => r.data);
export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);
export const submitPlanInquiry = (payload) =>
  api.post("/plan-inquiry", payload).then((r) => r.data);
